import React, { useEffect } from "react";
import "./index.less";
import { useMemoizedFn, useRequest } from "ahooks";
import { trackGdp } from "../../../../../../utils/gio-report";
import { goToPageV2 } from "../../../../../../utils/common";

export interface Props {
  code: string;
  data: any[];
  /** 页面 Id */
  pageId: string;
  /* 曝光埋点 Bid */
  exposeBid: string;
  /* 点击埋点 Bid */
  clickBid: string;
}
const ResourceBanner = (props: Props) => {
  const { code, pageId = "", exposeBid = "", clickBid = "" } = props;
  const data = props.data?.[0];

  const hasBanner = !!data?.itemId;

  useEffect(() => {
    // 曝光上报
    if (hasBanner) {
      trackGdp(pageId, exposeBid, {
        template_id: code,
        advert_id: data?.itemId,
        pic_code: data?.materialList?.[0].materialId,
        url: data?.materialList?.[0].jumpUrl
      });
    }
  }, [hasBanner, data]);

  const handleClick = useMemoizedFn(() => {
    const url = data?.materialList?.[0].jumpUrl;
    trackGdp(pageId, clickBid, {
      template_id: code,
      advert_id: data?.itemId,
      pic_code: data?.materialId,
      url: data?.jumpUrl
    });
    if (!url) {
      return;
    }

    if (
      url
        ?.split("&")
        ?.find(item => item.includes("goLink"))
        ?.split("=")[1] === "false"
    ) {
      return;
    }

    goToPageV2({ url });
  });

  if (!hasBanner) {
    return null;
  }
  return (
    <div onClick={handleClick} className="pile-sharing-apply-resource-banner">
      <img src={data?.materialList?.[0].url} alt="" />
    </div>
  );
};

export default ResourceBanner;
